import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import AppWorkflow from "../components/beranda_page/AppWorkflow";
import BestSellingProductsSection from "../components/beranda_page/BestSellingProductsSection";
import PartnershipPromoSection from "../components/beranda_page/PartnershipPromoSection";
import ProductsRecommendationSection from "../components/beranda_page/ProductsRecommendationSection";
import TrendingBlogSection from "../components/beranda_page/TrendingBlogSection";
import useCustomToast from "../lib/useCustomToast";
import { useFetchLanding } from "../store/useFetchLanding";
import { MetaTag } from "../utils/MetaTag";

const Beranda = () => {
  const toast = useCustomToast();

  const { data, isLoading, error, fetchLanding } = useFetchLanding();

  useEffect(() => {
    if (!data) {
      fetchLanding();
    }
  }, [fetchLanding, data]);

  useEffect(() => {
    if (error) {
      return toast({
        description: error,
      });
    }
  }, [error]);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={{ base: "50px", xl: "99px" }}
      w={"full"}
      py={"20px"}
      px={{
        base: "12px",
        sm: "24px",
        md: "32px",
        lg: "40px",
        xl: "48px",
        "2xl": 0,
      }}
    >
      <MetaTag
        title="BisnisLink"
        description="Platform penghubung UMKM sebagai Supplier dengan Reseller yang siap membantu memasarkan produk secara online."
      />

      <PartnershipPromoSection
        carouselData={data?.sliders}
        isCarouselDataLoading={isLoading}
      />

      <AppWorkflow
        roleList={data?.galleries}
        isRoleListDataLoading={isLoading}
      />
      <ProductsRecommendationSection
        productRecomendations={data?.recomendationProducts}
        isProductRecomendationsLoading={isLoading}
      />
      <BestSellingProductsSection
        isBestSellingProductsDataLoading={isLoading}
        bestSellingProductsData={data?.mostSaledProducts}
      />
      <TrendingBlogSection
        blogData={data?.posts}
        isBlogDataLoading={isLoading}
      />
    </Box>
  );
};

export default Beranda;
